import Vue from 'vue'

// Toast component
const ToastComponent = Vue.extend({
  template: `
    <transition name="toast-fade">
      <div v-if="visible" :class="['toast', 'toast--' + type]" :style="positionStyle">
        <div class="toast__content">
          <span class="toast__message">{{ message }}</span>
          <button class="toast__close" @click="close">×</button>
        </div>
      </div>
    </transition>
  `,
  data() {
    return {
      visible: false,
      message: '',
      type: 'info',
      duration: 3000,
      position: 'top-right'
    }
  },
  computed: {
    positionStyle() {
      const positions = {
        'top-right': { top: '20px', right: '20px' },
        'top-left': { top: '20px', left: '20px' },
        'bottom-right': { bottom: '20px', right: '20px' },
        'bottom-left': { bottom: '20px', left: '20px' },
        'top-center': { top: '20px', left: '50%', transform: 'translateX(-50%)' },
        'bottom-center': { bottom: '20px', left: '50%', transform: 'translateX(-50%)' }
      }
      return positions[this.position] || positions['top-right']
    }
  },
  mounted() {
    this.visible = true
    if (this.duration > 0) {
      setTimeout(() => {
        this.close()
      }, this.duration)
    }
  },
  methods: {
    close() {
      this.visible = false
      setTimeout(() => {
        if (this.$el && this.$el.parentNode) {
          this.$el.parentNode.removeChild(this.$el)
        }
        this.$destroy()
      }, 300)
    }
  }
})

// Toast plugin
const ToastPlugin = {
  install(Vue) {
    const toastContainer = document.createElement('div')
    toastContainer.id = 'toast-container'
    toastContainer.style.cssText = 'position: fixed; z-index: 10000; pointer-events: none;'
    document.body.appendChild(toastContainer)

    const showToast = (message, type = 'info', options = {}) => {
      const toast = new ToastComponent({
        data: {
          message,
          type,
          duration: options.duration || 3000,
          position: options.position || 'top-right'
        }
      })
      toast.$mount()
      toastContainer.appendChild(toast.$el)
      return toast
    }

    Vue.prototype.$toast = {
      success(message, options) {
        return showToast(message, 'success', options)
      },
      error(message, options) {
        return showToast(message, 'error', options)
      },
      warning(message, options) {
        return showToast(message, 'warning', options)
      },
      info(message, options) {
        return showToast(message, 'info', options)
      }
    }
  }
}

export default ToastPlugin



















// WEBPACK FOOTER //
// ./src/utils/toast.js